// src/config/csvConfig.js

// Diccionario de URLs de CSV por idioma
export const CSV_URLS = {
  es: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTs0fjELaBzpjH2pM_KknrnlQj_QrmyX_orKUBFWv0oICYfVBBcaEhBN-QYv_LHJiFOOgKv02aJ2ZBe/pub?gid=791852477&single=true&output=csv', // Hoja 1 (español)
  en: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTs0fjELaBzpjH2pM_KknrnlQj_QrmyX_orKUBFWv0oICYfVBBcaEhBN-QYv_LHJiFOOgKv02aJ2ZBe/pub?gid=1779304048&single=true&output=csv', // Hoja 2 (inglés) 
  pt: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTs0fjELaBzpjH2pM_KknrnlQj_QrmyX_orKUBFWv0oICYfVBBcaEhBN-QYv_LHJiFOOgKv02aJ2ZBe/pub?gid=355508194&single=true&output=csv'  // Hoja 3 (portugués) 
};

// Para obtener el gid de cada hoja:
// 1. Ve a tu Google Sheets
// 2. Haz clic en la pestaña de la hoja (Hoja 2, Hoja 3)
// 3. Copia la URL, verás algo como: #gid=123456789
// 4. Reemplaza SHEET_ID_EN y SHEET_ID_PT con esos números